import { RenderCapable } from "../RenderEngine/RenderEnum/RenderCapable";
import { TextureDimension } from "../RenderEngine/RenderEnum/TextureDimension";
import { TextureFormat } from "../RenderEngine/RenderEnum/TextureFormat";
import { LayaGL } from "../layagl/LayaGL";
import { BaseTexture } from "./BaseTexture";
export class Texture3D extends BaseTexture {
    static get defaultTexture() {
        return this._defaultTexture;
    }
    static __init__() {
        if (LayaGL.renderEngine.getCapable(RenderCapable.Texture3D)) {
            this._defaultTexture = new Texture3D(1, 1, 1, TextureFormat.R8G8B8A8, false, false);
            this._defaultTexture.lock = true;
            this._defaultTexture.setPixelsData(new Uint8Array([255, 255, 255, 255]));
        }
    }
    constructor(width, height, depth, format, mipmap = true, sRGB = false) {
        super(width, height, format);
        this._dimension = TextureDimension.Tex3D;
        this.depth = depth;
        this._gammaSpace = sRGB;
        let context = LayaGL.textureContext;
        this._texture = context.createTexture3DInternal(this._dimension, width, height, depth, format, mipmap, sRGB, false);
    }
    setPixelsData(source) {
        let texture = this._texture;
        let context = LayaGL.textureContext;
        context.setTexture3DPixelsData(texture, source, this.depth, false, false);
    }
    setSubPixelsData(xOffset, yOffset, zOffset, width, height, depth, pixels, mipmapLevel, generateMipmap) {
        let texture = this._texture;
        let context = LayaGL.textureContext;
        context.setTexture3DSubPixelsData(texture, pixels, mipmapLevel, generateMipmap, xOffset, yOffset, zOffset, width, height, depth, false, false);
    }
}
